import { lockBodyScroll, unlockBodyScroll } from './body-scroll-lock';

export const initMobileMenu = () => {
  const header = document.querySelector('.header-site');
  const burgerButton = document.querySelector('.header-site__burger-button');
  const mobileMenu = document.querySelector('.header-site__mobile-menu');
  const mobileCloseButton = document.querySelector('.header-site__mobile-close');
  const searchButton = document.querySelector('.header-site__search-button');
  const desktopMediaQuery = window.matchMedia('(min-width: 1024px)');

  if (!header || !burgerButton || !mobileMenu || !mobileCloseButton) {
    return;
  }

  let isMenuOpen = false;

  const setMenuState = (isOpen) => {
    if (isOpen === isMenuOpen) {
      return;
    }

    isMenuOpen = isOpen;
    header.classList.toggle('header-site--menu-open', isOpen);
    burgerButton.setAttribute('aria-expanded', String(isOpen));
    mobileMenu.setAttribute('aria-hidden', String(!isOpen));

    if (isOpen) {
      lockBodyScroll();
    } else {
      unlockBodyScroll();
    }
  };

  burgerButton.addEventListener('click', () => {
    header.classList.remove('header-site--search-open');
    searchButton?.setAttribute('aria-expanded', 'false');
    setMenuState(true);
  });

  mobileCloseButton.addEventListener('click', () => {
    setMenuState(false);
  });

  mobileMenu.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    const toggleButton = target.closest('.nav__toggle');

    if (toggleButton) {
      const item = toggleButton.closest('.nav__item--has-children');

      if (!item) {
        return;
      }

      const isOpen = item.classList.toggle('nav__item--open');

      toggleButton.setAttribute('aria-expanded', String(isOpen));
      event.preventDefault();
      return;
    }

    const link = target.closest('.nav__item--has-children > .nav__row > .nav__link');

    if (link) {
      const item = link.closest('.nav__item--has-children');

      if (!item) {
        return;
      }

      if (!item.classList.contains('nav__item--open')) {
        item.classList.add('nav__item--open');
        item
          .querySelector(':scope > .nav__row .nav__toggle')
          ?.setAttribute('aria-expanded', 'true');
        event.preventDefault();
        return;
      }
    }

    const plainLink = target.closest('.nav__link');

    if (plainLink) {
      setMenuState(false);
    }
  });

  const handleDesktopBreakpoint = (event) => {
    if (event.matches) {
      setMenuState(false);
    }
  };

  if (typeof desktopMediaQuery.addEventListener === 'function') {
    desktopMediaQuery.addEventListener('change', handleDesktopBreakpoint);
  } else if (typeof desktopMediaQuery.addListener === 'function') {
    desktopMediaQuery.addListener(handleDesktopBreakpoint);
  }
};
